import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Col, Row, Card, CardBody, Badge, Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Spinner, Alert
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanagelapi.stechomeyazilim.info";

const MagazaYonetimi = () => {
  document.title = "Mağaza Yönetimi | HarmanaGEL";

  const [magazalar, setMagazalar] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");

  const [detailModal, setDetailModal] = useState(false);
  const [selectedMagaza, setSelectedMagaza] = useState(null);

  const fetchMagazalar = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/MAGAZALAR?$top=500&$orderby=OLUSTURMA_TARIHI desc&$expand=KULLANICILAR($select=AD_SOYAD,Mail_Adress,CEP_NO)`
      );
      const result = await response.json();
      if (result && result.value) setMagazalar(result.value);
    } catch (err) {
      setError("Mağazalar yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMagazalar();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Bu mağazayı silmek istediğinize emin misiniz?")) return;
    try {
      await fetch(`${BASE_URL}/MAGAZALAR(${id})`, { method: "DELETE" });
      setSuccessMsg("Mağaza silindi.");
      fetchMagazalar();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) {
      setError("Silme sırasında hata oluştu.");
    }
  };

  const handleViewDetail = (magaza) => {
    setSelectedMagaza(magaza);
    setDetailModal(true);
  };

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-medium">#{cell.getValue()}</span>,
    },
    {
      header: "Mağaza Adı",
      accessorKey: "MAGAZA_ADI",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => (
        <div className="d-flex align-items-center gap-2">
          {cell.row.original.LOGO_URL ? (
            <img
              src={cell.row.original.LOGO_URL}
              alt=""
              style={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover" }}
            />
          ) : (
            <div
              className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: 36, height: 36, fontSize: 14 }}
            >
              {cell.getValue()?.charAt(0)}
            </div>
          )}
          <div>
            <div className="fw-medium">{cell.getValue()}</div>
            <small className="text-muted">{cell.row.original.IL} / {cell.row.original.ILCE}</small>
          </div>
        </div>
      ),
    },
    {
      header: "Sahip",
      accessorKey: "KULLANICILAR",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => {
        const u = cell.getValue();
        return u ? (
          <div>
            <div className="fw-medium">{u.AD_SOYAD}</div>
            <small className="text-muted">{u.Mail_Adress}</small>
          </div>
        ) : "-";
      },
    },
    {
      header: "Vergi No",
      accessorKey: "VERGI_NO",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => cell.getValue() || "-",
    },
    {
      header: "Telefon",
      accessorKey: "TELEFON",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => cell.getValue() || "-",
    },
    {
      header: "Kayıt Tarihi",
      accessorKey: "OLUSTURMA_TARIHI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const d = cell.getValue();
        return d ? new Date(d).toLocaleDateString("tr-TR") : "-";
      },
    },
    {
      header: "İşlemler",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cellProps) => {
        const m = cellProps.row.original;
        return (
          <div className="d-flex gap-2">
            <Button color="info" size="sm" outline onClick={() => handleViewDetail(m)}>
              <i className="bx bx-detail" />
            </Button>
            <Button color="danger" size="sm" outline onClick={() => handleDelete(m.ID)}>
              <i className="bx bx-trash" />
            </Button>
          </div>
        );
      },
    },
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Mağaza Yönetimi" />

          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">Mağazalar</h4>
                    <Button color="primary" size="sm" onClick={fetchMagazalar} disabled={isLoading}>
                      <i className="bx bx-refresh me-1" />
                      Yenile
                    </Button>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5">
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={magazalar}
                      isGlobalFilter={true}
                      SearchPlaceholder="Mağaza ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* Detay Modal */}
      <Modal isOpen={detailModal} toggle={() => setDetailModal(false)} size="lg" centered>
        <ModalHeader toggle={() => setDetailModal(false)}>
          Mağaza Detayı: {selectedMagaza?.MAGAZA_ADI}
        </ModalHeader>
        <ModalBody>
          {selectedMagaza && (
            <Row>
              <Col md={6}>
                <table className="table table-sm table-bordered">
                  <tbody>
                    <tr><th>Mağaza Adı</th><td>{selectedMagaza.MAGAZA_ADI}</td></tr>
                    <tr><th>Vergi No</th><td>{selectedMagaza.VERGI_NO || "-"}</td></tr>
                    <tr><th>Vergi Dairesi</th><td>{selectedMagaza.VERGI_DAIRESI || "-"}</td></tr>
                    <tr><th>Telefon</th><td>{selectedMagaza.TELEFON || "-"}</td></tr>
                    <tr><th>İl / İlçe</th><td>{selectedMagaza.IL} / {selectedMagaza.ILCE}</td></tr>
                    <tr><th>Açık Adres</th><td>{selectedMagaza.ACIK_ADRES || "-"}</td></tr>
                    <tr><th>Kayıt Tarihi</th><td>{selectedMagaza.OLUSTURMA_TARIHI ? new Date(selectedMagaza.OLUSTURMA_TARIHI).toLocaleDateString("tr-TR") : "-"}</td></tr>
                  </tbody>
                </table>
              </Col>
              <Col md={6}>
                <p><strong>Sahip:</strong> {selectedMagaza.KULLANICILAR?.AD_SOYAD || "-"}</p>
                <p><strong>E-posta:</strong> {selectedMagaza.KULLANICILAR?.Mail_Adress || "-"}</p>
                <p><strong>Telefon:</strong> {selectedMagaza.KULLANICILAR?.CEP_NO || "-"}</p>
                <hr />
                <p><strong>Açıklama:</strong></p>
                <p className="text-muted">{selectedMagaza.ACIKLAMA || "Açıklama yok"}</p>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setDetailModal(false)}>Kapat</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default MagazaYonetimi;
